import { render, staticRenderFns } from "./ParentPage.vue?vue&type=template&id=e428d06a&scoped=true&"
import script from "./ParentPage.vue?vue&type=script&lang=js&"
export * from "./ParentPage.vue?vue&type=script&lang=js&"
import style0 from "./ParentPage.vue?vue&type=style&index=0&id=e428d06a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e428d06a",
  null
  
)

export default component.exports